// extracted by mini-css-extract-plugin
export var equalColumn = "_jj-0";